import { cx } from '@flowus/common/cx';
import type { FC } from 'react';
import { Icon } from 'src/common/components/icon';
import { Tooltip } from 'src/common/components/tooltip';
import { useIsInRight } from 'src/utils/right-utils';
import { PageFeedTabIndex, setPageFeedIndex } from '../drawer/page-feeds/page-feeds';
import { useDrawerOpenState } from '../drawer/shared';

export const PageFeedsButton: FC<{ className?: string }> = ({ className }) => {
  const [drawState, setDrawState] = useDrawerOpenState();
  const isInRight = useIsInRight();
  const hover =
    (isInRight && drawState === 'page-feeds-right') || (!isInRight && drawState === 'page-feeds');
  return (
    <Tooltip
      popup={drawState ? '关闭页面信息' : '查看页面信息'}
      className={cx(
        'flex items-center justify-center animate-hover',
        hover && 'bg-black_006',
        className
      )}
      onClick={() => {
        setPageFeedIndex(PageFeedTabIndex.PAGE_INFO);
        if (isInRight) {
          setDrawState(drawState !== 'page-feeds-right' ? 'page-feeds-right' : false);
        } else {
          setDrawState(drawState !== 'page-feeds' ? 'page-feeds' : false);
        }
      }}
    >
      <Icon name={'IcInfoMiddleBold'} size="small" boxSize="large" />
    </Tooltip>
  );
};
